module.exports = __webpack_public_path__ + "media/share_images/drum-44a0000b.svg";